import properties from './properties'

export default {
    namespaced: true,
    modules: {
        properties
    }
}
